/* eslint-disable @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access */
import { IPropertyConverter, JsonValue, TaJson } from "ta-json";

import { InvalidOperationError } from "../errors/invalid-operation-error";
import Link from "../link";
import { RelationMapResource } from "../models/relation-map-resource";
import { RelationResource } from "../models/relation-resource";

export class RelationMapResourceConverter implements IPropertyConverter {
    serialize(value: RelationMapResource): JsonValue {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return TaJson.serialize(value);
    }

    deserialize(value: JsonValue): RelationMapResource {
        if (!value) {
            throw new InvalidOperationError("Can't deserialize falsy value.");
        } else if (typeof value !== "object" || value instanceof Array) {
            throw new InvalidOperationError(
                `Expected a value of type 'JSON', but value was of type '${typeof value}'.`
            );
        }

        let obj: any = null;

        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        typeof value === "string" ? (obj = JSON.parse(value)) : (obj = JSON.parse(JSON.stringify(value)));
        try {
            return Object.keys(obj).reduce((map: { [key: string]: RelationResource | Link }, relationName) => {
                const resource = obj[relationName];
                map[relationName] = resource.href
                    ? TaJson.deserialize<Link>(resource, Link)
                    : TaJson.deserialize<RelationResource>(resource, RelationResource);
                return map;
            }, {});
        } catch (ex) {
            throw new InvalidOperationError(`Couldn't deserialize this JsonValue - ${ex}.`);
        }
    }
}
